module.exports = __webpack_public_path__ + "img/logo_beantobear.54051432.jpg";